// ** Initial State
const initialState = {
  allBooths: [],
  allBoothGroups: [],
  booth: [],
  data: [],
  boothData: [],
  next: [],
  previous: [],
  membership: null,
  pageLoader:true,
  boothUploadedStatus: null,

}

const booths = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_BOOTH':
      return { ...state, allBooths: action.data, booth: action.data }

    case 'GET_ALL_BOOTH_GROUPS':
      return { ...state, allBoothGroups: action.data }

    case 'GET_BOOTH':
      return {
        ...state,
        data: action.data,
        booth: action.data.booth,
        next: action.data.next,
        previous: action.data.previous,
        membership: action.data.membership,
        pageLoader:false
      }
    case 'CLEAR_BOOTH':
      return {
        ...state,
        data: [],
        booth: [],
        next: [],
        previous: [],
        membership: null
      }
    case 'SET_BOOTH':
      return {
        ...state,
        data: [],
      }

      case 'GET_VENDOR_BOOTH':
        return {
          ...state,
          data: action.data,
        }
   
    case 'ADD_BOOTH':
      return {
        ...state,
        allBooths: [...state.allBooths, action.data],
        booth: action.data
      }
      
    case 'UPDATE_BOOTH':
      return {
        ...state,
        booth: action.data
      }
    case 'DELETE_BOOTH':
      return { 
        ...state,
        allBooths: [...state.allBooths, action.data]
     }
    case 'PAGE_LOADER':
      return { ...state, pageLoader: action.data }
    case 'UPDATE_UPLOADED_STATUS':
      return { ...state, boothUploadedStatus: action.data}
    default:
      return { ...state }
  }
}
export default booths
